<template>
  <footer class="totals-bar">
    <div class="info">
      <span class="price">
        <em v-html="$options.filters.toUSD(finalPerAcreCost)"></em><span class="label">/ Acre</span>
      </span>
      <span class="total">
        <span>total</span> <em class="label" v-html="$options.filters.supDecimals($options.filters.toUSD(totalCost))"></em>
      </span>
      <span class="total" v-if="discount">{{ discount }}% discount</span>
    </div>
    <div class="summary">
      <div class="condensed">
        <button class="toggle" ref="summaryToggle" @click="summaryDropdownOpen = !summaryDropdownOpen" :class="{'is-open': summaryDropdownOpen}">Mix Summary</button> <span class="label">{{ cropRatesSum }}/{{ mixTarget }}%</span>
        <div class="progress-bar"><span class="progress" :style="'width:' + progressWidth + '%'"></span></div>
      </div>
      <div class="dropdown"
        v-closable="{ exclude: ['summaryToggle'], handler: 'handleClose' }"
        :class="{'is-open': summaryDropdownOpen}">
          <summary-table
            :sum="cropRatesSum"
            :target="mixTarget"
            :canEdit="canEdit"
            @edit="handleEdit"
            @remove="handleRemove"></summary-table>
          <div class="footer" v-if="this.$store.state.formData.selectedCrops.length">
            <button @click="handleClear">Clear All</button>
          </div>
      </div>
    </div>
    <div class="button">
      <button class="btn btn-primary has-arrow" :disabled="numberOfItems < 1" @click="$emit('next', true)">Next</button>
    </div>
  </footer>
</template>

<script>
import SummaryTable from '@/components/SummaryTable'
export default {
  data () {
    return {
      summaryDropdownOpen: false,
      canEdit: true
    }
  },
  components: {
    'summary-table': SummaryTable
  },
  methods: {
    handleClear () {
      this.summaryDropdownOpen = false
      this.$emit('reset')
    },
    handleClose () {
      this.summaryDropdownOpen = false
    },
    handleEdit (entry) {
      this.$emit('edit', entry)
    },
    handleRemove (crop) {
      this.$emit('remove', crop)
    },
    getFormattedValue (value) {
      return Math.round(value * 100) / 100
    }
  },
  computed: {
    numberOfItems () {
      return this.$store.state.formData.selectedCrops.length
    },
    perAcreCost () {
      return this.$store.state.totals.seedCostPerAcre + this.$store.state.totals.blendingFeePerAcre
    },
    finalPerAcreCost () {
      return this.getFormattedValue(this.perAcreCost - (this.perAcreCost * this.discount / 100))
    },
    totalCost () {
      return this.finalPerAcreCost * this.$store.state.formData.acres
    },
    discount () {
      return this.$store.state.totals.discount
    },
    mixTarget () {
      return this.$store.state.mixTargets[this.$store.state.formData.plantingMethod]
    },
    progressWidth () {
      let width = this.cropRatesSum / this.mixTarget * 100
      if (width > 100) {
        width = 100
      }
      return width
    },
    cropRatesSum () {
      let sum = 0
      this.$store.state.formData.selectedCrops.forEach((entry, index) => {
        sum += entry.amount / entry.crop.seedingRate * 100
      })
      return Math.round(sum * 100) / 100
    }
  }
}
</script>

<style lang="scss">
  .content.has-totals{
    #header{
      top: $totalsbar-height-xs + 10;
      @include media-breakpoint-up(lg){
        top: $totalsbar-height + 20;
      }
    }
  }
  .totals-bar {
    position: fixed;
    z-index: $zi-ui;
    display: flex;
    align-items: center;
    justify-content: space-between;
    left: 0;
    bottom: 0;
    width: 100vw;
    background: $color-dark-green;
    transition: left $ui-transition ease;
    height: $totalsbar-height-xs;
    padding: 0 0 0 15px;
    @include media-breakpoint-up(lg){
      height: $totalsbar-height;
      top: 0;
      left: $sidebar-width + 1px;
      right: 0;
      bottom: auto;
      width: auto;
      padding: 0 30px;
    }
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      color: $color-white;
      flex: 1;
      padding-right: 15px;
      @include media-breakpoint-up(md){
        justify-content: flex-start;
        flex: initial;
        padding: 0;
      }
      > span {
        display: block;
      }
      em {
        font-style: normal;
      }
      .label{
        padding-left: 5px;
      }
      .price {
        font-size: 12px;
        letter-spacing: 1px;
        font-weight: 600;
        text-transform: uppercase;
        display: flex;
        align-items: center;
        @include media-breakpoint-up(md){
          font-size: 14px;
          margin-right: 20px;
        }
        em {
          font-size: 18px;
          font-weight: 400;
          letter-spacing: 0;
          @include media-breakpoint-up(md){
            font-size: 30px;
            margin-right: 10;
          }
        }
      }
      .total {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
        text-transform: uppercase;
        opacity: .5;
        sup{
          top: 0;
          font-size: 100%;
        }
        span{
          @include media-breakpoint-down(md){
            display: none;
          }
        }
      }
      .total + .total{
        margin-left: 20px;
        color: $color-neon-green;
        opacity: 1;
        @include media-breakpoint-down(sm){
          display: none; // no room for this on mobile
        }
      }
      .count {
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 1px;
        text-transform: uppercase;
        color: $color-neon-green;
        display: flex;
        align-items: center;
        margin-left: auto;
        em {
          letter-spacing: 0;
          font-size: 30px;
          font-weight: 400;
        }
      }
    }
    .summary{
      padding: 0;
      margin: 0;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      @include media-breakpoint-down(md){
        bottom: $totalsbar-height-xs;
        background: $color-dark-green;
        width: 100vw;
        border-bottom: solid 1px $color-green;
      }
      @media screen and (min-width: 992px) and (max-width: 1540px){
        position: static;
        transform: none;
      }
      .condensed{
        display: flex;
        align-items: center;
        justify-content: space-between;
        @include media-breakpoint-up(lg){
          flex-wrap: wrap;
          width: 204px;
        }
      }
      .toggle{
        @include resetButton;
        font-size: 12px;
        font-weight: 600;
        text-transform: uppercase;
        color: $color-white;
        letter-spacing: 1px;
        white-space: nowrap;
        height: 30px;
        margin-left: 15px;;
        @include media-breakpoint-up(lg){
          font-size: 14px;
          height: auto;
          margin: 0;
        }
        &:focus{
          outline: none;
        }
        &.is-open {
          &::after {
            transform: rotate(0);
            @include media-breakpoint-up(lg){
              transform: rotate(-180deg);
            }
          }
        }
        &::after{
          content: '';
          width: 8px;
          height: 8px;
          margin-left: 6px;
          background: url('/assets/dropdown-arrow.svg') no-repeat center center;
          background-size: 100% auto;
          display: inline-block;
          transition: all 0.2s ease-in-out;
          transform: rotate(-180deg);
          @include media-breakpoint-up(lg){
            width: 10px;
            height: 10px;
            transform: none;
          }
        }
      }
      .progress-bar{
        background: rgba($color-white,.15);
        width: 120px;
        margin-right: 10px;
        @include media-breakpoint-up(lg){
          width: 100%;
          margin: 0;
        }
      }
      .label{
        font-size: 14px;
        font-weight: 600;
        text-transform: uppercase;
        color: $color-neon-green;
        letter-spacing: 1px;
        order: 9;
        margin-right: 15px;
        @include media-breakpoint-up(lg){
          margin-right: 0;
          order: 0;
        }
      }
      .dropdown{
        background: $color-dark-white;
        display: none;
        color: $color-dark-green;
        @include media-breakpoint-up(lg){
          position: absolute;
          width: 444px;
          left: 50%;
          top: 130%;
          transform: translateX(-50%);
          box-shadow: 0px 20px 20px rgba(59, 68, 6, 0.45);
          border-radius: 3px;
        }
        &.is-open{
          display: block;
        }
        .summary-table{
          .header{
            padding-top: 15px;
            @include media-breakpoint-up(lg){
              padding-top: 30px;
            }
            .title h2{
              font-size: 20px;
            }
          }
        }
        .footer{
          border-top: solid 1px rgba($color-black, .15);
          text-align: center;
          button{
            @include resetButton;
            text-transform: uppercase;
            font-weight: 600;
            letter-spacing: 1px;
            color: $color-neon-green;
            font-size: 14px;
            padding: 15px 0 15px 20px;
            background: url('/assets/close-green.svg') no-repeat left center;
            background-size: 13px auto;
          }
        }
      }
    }
    .button {
      @include media-breakpoint-down(md){
        .btn{
          border-radius: 0;
        }
      }
      @include media-breakpoint-up(md){
        width: 157px;
        margin-left: 5px;
      }
    }
  }
</style>
